<template>
  <div class="plan_container mb40">
    <div class="plan_item">
      <div class="">
        <div>
          <div class="regular-fill-badge-grey50">
            Present
          </div>
        </div>
        <div class="pdt10">
          <span class="unit">$</span>
          <span class="amount">{{ computedPresentProduct.productAmount }}</span>
          <span class="unit"> {{ computedPresentProduct.productAmountUnit}}</span>
          <span class="period"> / {{ computedPresentTerm }}</span>
        </div>
      </div>
      <div class="underline"></div>
      <table class="service_table">
        <caption></caption>
        <tbody>
        <tr>
          <th id="temp1" class="txt_caption_1 --grey80">Plan</th>
          <td class="txt_caption_1 --grey80">{{ computedPresentProduct.defaultProductTitle }}</td>
        </tr>
        <tr>
          <th id="temp03" class="txt_caption_1 --grey80">Patients</th>
          <td class="txt_caption_1 --grey80">{{ computedPresentProduct.defaultProductSubTitle }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="arrow">
      <img src="/images/ic/comm/ic-trending.svg" alt=""/>
    </div>
    <div class="plan_item after">
      <div class="">
        <div>
          <div class="regular-fill-badge-blue70">
            Change
          </div>
        </div>
        <div class="pdt10">
          <span class="unit">$</span>
          <span class="amount">{{ computedChangeProduct.productAmount }}</span>
          <span class="unit"> {{ computedChangeProduct.productAmountUnit }}</span>
          <span class="period"> / {{ computedChangeTerm }}</span>
        </div>
      </div>
      <div class="underline"></div>
      <table class="service_table">
        <caption></caption>
        <tbody>
        <tr>
          <th id="temp4" class="txt_caption_1 --grey80">Plan</th>
          <td class="txt_caption_1 --grey80">{{ computedChangeProduct.defaultProductTitle }}</td>
        </tr>
        <tr>
          <th id="temp06" class="txt_caption_1 --grey80">Patients</th>
          <td class="txt_caption_1 --grey80">{{ computedChangeProduct.defaultProductSubTitle }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'changedServicePlan',
  props: {
    modalInfoProps: Object
  },
  computed: {
    computedPresentProduct() {
      const present = this.modalInfoProps.data.productList.filter(item => {
        return item.seqProduct === this.modalInfoProps.data.present.selectedProduct;
      })
      return present[0]
    },
    computedPresentTerm() {
      const term = this.modalInfoProps.data.term.filter(item => {
        return item.type === this.modalInfoProps.data.present.selectedTerm.type;
      });
      return term[0].trans;
    },
    computedChangeProduct() {
      const change = this.modalInfoProps.data.productList.filter(item => {
        if (this.modalInfoProps.data.change.selectedProduct === false) {
          return item.seqProduct === this.modalInfoProps.data.present.selectedProduct;
        } else {
          return item.seqProduct === this.modalInfoProps.data.change.selectedProduct;
        }
      })
      return change[0]
    },
    computedChangeTerm() {
      const term = this.modalInfoProps.data.term.filter(item => {
          return item.type === this.modalInfoProps.data.change.selectedTerm.type;
      });
      return term[0].trans;
    },
  }
}
</script>